import thinkingdata from 'thinkingdata-browser'

import Client from '@/commonFunc/client.js'
import Request from '@/utils/request.js'
import SecretKey from '@/config/secret-key.js'
import BaseConfig from '@/config/base.js'

import { getTraceStore } from '@/utils/storage.js'
import { decryptCode } from '@/utils/common.js'
import { flushTaPageViewQueue } from '@/utils/ta-page-view.js'
import { getLandingTrafficSuperProps } from '@/utils/ta-landing.js'

// 用拉取的 appId/url 初始化数数 SDK
// 设置 login/super 属性，并补发 PV 队列与 traceAction 缓存（含 uid 与匿名）
function initThinkingData(jsonObj) {
  if (!jsonObj || !jsonObj.appId || !jsonObj.url) {
    return
  }
  window.ta = thinkingdata
  window.ta.init({
    appId: jsonObj.appId || '',
    serverUrl: jsonObj.url || '',
    // 缓存>批量发送
    batch: false,
    autoTrack: {
      pageShow: false,
      pageHide: false,
    },
    // mode: "debug"
  })

  const uid = Client.getUserBaseInfo().uid

  ta.login(uid || '')
  let landingSuperProps = {}
  try {
    landingSuperProps = getLandingTrafficSuperProps()
  } catch (e) {
    console.log('getLandingTrafficSuperProps', e)
  }
  window.ta.setSuperProperties({
    channel: Client.getAppInfo().channel || '',
    ...landingSuperProps,
  })

  flushTaPageViewQueue()

  // 补发用户队列（有 uid 场景）
  if (window.ta && uid) {
    const sotreTraceArr = getTraceStore(`thinkingdata_${uid}`)
    if (Array.isArray(sotreTraceArr)) {
      // 清理缓存
      window.localStorage.removeItem(`thinkingdata_${uid}`)
      // 上报数数
      sotreTraceArr.forEach((item) => {
        window.ta.track('h5_page_track', item)
      })
    }
  }

  // 补发匿名队列（无 uid 场景，如站外浏览器打开下载页）
  if (window.ta) {
    const anonymousTraceArr = getTraceStore('thinkingdata_anonymous')
    if (Array.isArray(anonymousTraceArr) && anonymousTraceArr.length) {
      window.localStorage.removeItem('thinkingdata_anonymous')
      anonymousTraceArr.forEach((item) => {
        window.ta.track('h5_page_track', item)
      })
    }
  }
}

// 模块加载即触发：
// Release 环境按 App 内 登录态选 aws/key，否则走 ss/key
// 拿到 key 后解密并 init SDK
try {
  const isLogin = !!Client.getUserBaseInfo().uid
  if (BaseConfig.isRelease) {
    const isApp = Client.env.isApp
    const req =
      isApp && isLogin
        ? Request({ url: '/api/v2/comm/aws/key?type=1', method: 'get', envelope: false })
        : Request({ url: '/api/v2/comm/ss/key', method: 'get', envelope: false })

    req.then((resData) => {
      initThinkingData(JSON.parse(decryptCode(resData, SecretKey.pk)))
    })
  }
} catch (err) {
  console.log('try catch', err)
}
